/**
 * Workshop Cart Integration
 *
 * Add-to-cart: JSON (items array). Properties için güvenilir; FormData properties kaybettirebilir.
 */

// Global init guard: prevent duplicate execution (idempotent)
// CRITICAL: This prevents the script from executing twice if loaded multiple times
(function() {
  'use strict';
  
  if (window.__WORKSHOP_CART_INIT__) {
    if (window.__DEBUG_WORKSHOP_CAPACITY__) {
      console.log('[Workshop Cart] Already initialized, skipping');
    }
    return; // Exit early to prevent duplicate execution
  }
  window.__WORKSHOP_CART_INIT__ = true;

document.addEventListener('DOMContentLoaded', () => {
  // Guard: prevent double event binding
  if (window.__workshopCartBound) {
    if (window.__DEBUG_WORKSHOP_CAPACITY__) {
      console.log('[Workshop Cart] Event listeners already bound, skipping');
    }
    return;
  }
  window.__workshopCartBound = true;

  if (window.__DEBUG_WORKSHOP_CAPACITY__) {
    console.log('[Workshop Cart] Initializing event listeners');
  }

  /**
   * JSON items format for cart/add.js (Shopify documented format).
   * Properties are reliably stored as line item properties -> Cart Transform attributes.
   */
  function buildCartAddPayload(variantId, quantity, properties, sections = []) {
    var item = {
      id: parseInt(String(variantId), 10),
      quantity: Math.max(1, parseInt(String(quantity), 10) || 1),
      properties: {}
    };
    for (var k in (properties || {})) {
      if (properties[k] != null && properties[k] !== '') {
        item.properties[k] = String(properties[k]);
      }
    }
    var payload = { items: [item] };
    if (Array.isArray(sections) && sections.length > 0) {
      payload.sections = sections.join(',');
      payload.sections_url = (typeof window !== 'undefined' && window.location && window.location.pathname) || '/';
    }
    return payload;
  }

  // Intercept all product form submissions
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    
    // Only handle product add-to-cart forms
    if (!form || !form.action || !form.action.includes('/cart/add')) return;
    if (!form.classList.contains('form') || form.getAttribute('data-type') !== 'add-to-cart-form') return;

    // Check if this is a workshop product
    const workshopInput = form.querySelector('[name="properties[workshop]"]');
    if (!workshopInput || workshopInput.value !== 'true') return;

    e.preventDefault();
    if (window.__WORKSHOP_ADDING_TO_CART__) return;

    // Get selected event data from global selection state
    const selection = window.__WORKSHOP_SELECTION__;
    if (!selection || !selection.eventId) {
      alert('Please select an event before adding to cart.');
      return;
    }

    const selectedEventId = selection.eventId;
    
    // Get booking container for resolver access
    const bookingContainer = document.querySelector('.workshop-booking');
    if (!bookingContainer) {
      console.warn('Workshop cart: booking container not found');
      return;
    }

    // Find the selected event card to get event data
    const eventsRoot = bookingContainer.querySelector('[data-workshop-events]');
    if (!eventsRoot) {
      console.warn('Workshop cart: events list not found');
      return;
    }

    const selectedCard = eventsRoot.querySelector(`.workshop-event-card[data-event-id="${CSS.escape(selectedEventId)}"]`);
    if (!selectedCard) {
      alert('Selected event not found. Please try again.');
      return;
    }

    if (window.wbEventBooking && typeof window.wbEventBooking.isBookable === 'function') {
      if (!window.wbEventBooking.isBookable(selectedCard)) {
        alert('This session is sold out. Please choose another time.');
        return;
      }
    }

    // Get event handle from card (must be metaobject handle, never numeric event_id)
    // CRITICAL: Block add-to-cart if handle is missing or numeric
    const datasetEventHandle = selectedCard.dataset.eventHandle || '';
    const eventHandle = datasetEventHandle;
    const looksNumeric = /^\d+$/.test(eventHandle);
    
    if (!eventHandle || looksNumeric || eventHandle === String(selectedEventId)) {
      const errorMsg = 'This workshop event is not available for booking. Please select a different event.';
      alert(errorMsg);
      console.error('[Workshop Cart] Add to cart blocked - invalid event_handle:', {
        eventHandle: eventHandle,
        selectedEventId: selectedEventId,
        looksNumeric: looksNumeric,
        reason: !eventHandle ? 'missing' : (looksNumeric ? 'numeric' : 'equals_event_id')
      });
      return;
    }

    // Optional debug logs
    if (window.__DEBUG_CART_ADD__ === true) {
      console.log('[Workshop Cart] Add to cart - event handle validation:', {
        eventId: selectedEventId,
        eventHandle: eventHandle,
        datasetEventHandle: datasetEventHandle,
        propertiesEventHandle: eventHandle
      });
    }

    // Get variant ID: form's [name="id"] or workshop hidden input #workshop-variant
    const variantIdInput = form.querySelector('[name="id"]') || bookingContainer.querySelector('#workshop-variant');
    if (!variantIdInput) {
      console.warn('Workshop cart: variant ID not found');
      return;
    }
    const variantId = variantIdInput.value;

    // CRITICAL FIX: Resolve price FRESH on every add-to-cart to prevent price leakage
    // Workshop uses button cards (data-base-price), not a select. Get base price from active variant button.
    const activeVariantBtn = bookingContainer.querySelector('.wb-variant-btn.is-active');
    const basePriceCents = activeVariantBtn && activeVariantBtn.dataset.basePrice
      ? Number(activeVariantBtn.dataset.basePrice)
      : null;
    if (!basePriceCents || Number.isNaN(basePriceCents) || basePriceCents <= 0) {
      alert('Unable to determine base price. Please refresh and try again.');
      return;
    }

    // Use selection state (from dataset attributes)
    const state = selection.state || selectedCard.dataset.state || '';
    const city = selection.city || selectedCard.dataset.city || '';
    const venueName = selection.venue || selectedCard.dataset.venueName || '';
    const cityKey = selectedCard?.dataset?.cityKey ? String(selectedCard.dataset.cityKey).trim() : '';
    const venueHandle = selectedCard?.dataset?.venueHandle ? String(selectedCard.dataset.venueHandle).trim() : '';

    // CRITICAL: Resolve price ONLY on Add to Cart (fresh resolution)
    let resolvedPriceCents = basePriceCents;
    if (window.resolveWorkshopPrice && typeof window.resolveWorkshopPrice === 'function') {
      try {
        // Get workshop product ID from booking container
        const workshopProductId = bookingContainer?.dataset?.productId || '';
        resolvedPriceCents = window.resolveWorkshopPrice({
          basePriceCents: basePriceCents,
          eventId: selectedEventId,
          state: state,
          city: city,
          cityKey: cityKey,
          venueName: venueName,
          venueHandle: venueHandle,
          variantId: variantId,
          workshopId: workshopProductId,
        });
      } catch (err) {
        console.warn('Workshop cart: Price resolver failed, using base price', err);
        resolvedPriceCents = basePriceCents;
      }
    }

    if (!Number.isFinite(resolvedPriceCents) || resolvedPriceCents <= 0) {
      alert('Unable to determine price. Please refresh and try again.');
      return;
    }

    // Build display properties (for cart/checkout UI) from selection state
    const displayCity = state ? `${city}, ${state}` : city;
    const displayVenue = venueName;
    const displayDatetime = selection.datetime || '';
    const bookingDetailsVisible = `${displayCity || ''}${displayVenue ? ` — ${displayVenue}` : ''}${displayDatetime ? ` · ${displayDatetime}` : ''}`.trim();

    // Get quantity
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = quantityInput ? Number(quantityInput.value) || 1 : 1;

    // Helper: Get total seats already in cart for a specific event from cart data (no fetch)
    function getSeatsFromCart(eventId, cart) {
      if (!cart || !cart.items || !Array.isArray(cart.items)) return 0;
      const eventIdStr = String(eventId || '');
      let totalSeats = 0;
      for (const item of cart.items) {
        if (!item.properties) continue;
        if (typeof item.properties === 'object' && !Array.isArray(item.properties)) {
          const gid = item.properties._event_metaobject_gid;
          const eid = item.properties._event_id ?? item.properties.event_id;
          if ((gid != null && String(gid) === eventIdStr) || (eid != null && String(eid) === eventIdStr)) {
            totalSeats += item.quantity || 0;
          }
        } else {
          for (const property of item.properties) {
            if (property && (property[0] === '_event_id' || property[0] === 'event_id') && String(property[1]) === eventIdStr) {
              totalSeats += item.quantity || 0;
              break;
            }
          }
        }
      }
      return totalSeats;
    }

    // Simple toast notification function
    function showToast(message, type = 'error') {
      // Create toast element
      const toast = document.createElement('div');
      toast.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: ${type === 'error' ? '#f44336' : '#4caf50'};
        color: white;
        padding: 16px 24px;
        border-radius: 4px;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        z-index: 10000;
        font-size: 14px;
        max-width: 400px;
        animation: slideIn 0.3s ease-out;
      `;
      toast.textContent = message;
      
      // Add animation
      const style = document.createElement('style');
      style.textContent = `
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        @keyframes slideOut {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(100%); opacity: 0; }
        }
      `;
      if (!document.head.querySelector('#workshop-toast-styles')) {
        style.id = 'workshop-toast-styles';
        document.head.appendChild(style);
      }
      
      document.body.appendChild(toast);
      
      // Remove after 4 seconds
      setTimeout(() => {
        toast.style.animation = 'slideOut 0.3s ease-out';
        setTimeout(() => {
          if (toast.parentNode) {
            toast.parentNode.removeChild(toast);
          }
        }, 300);
      }, 4000);
    }

    // Capacity check: use window.WORKSHOP_CAPACITY_API when set (SPEC), else fallback
    const CAPACITY_CHECK_URL = (typeof window !== 'undefined' && window.WORKSHOP_CAPACITY_API) || 'https://workshop-capacity-webhook-production.up.railway.app/capacity/check';

    async function checkWorkshopCapacity(eventId, requestedQuantity) {
      if (!eventId) {
        console.log('[CAPACITY CHECK]', { eventId, requestedQuantity, response: 'No event ID' });
        return { allowed: true, remaining_capacity: null };
      }

      try {
        const response = await fetch(CAPACITY_CHECK_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            event_id: eventId,
            requested_quantity: requestedQuantity
          })
        });

        if (!response.ok) {
          console.log('[CAPACITY CHECK]', { eventId, requestedQuantity, response: `HTTP ${response.status}` });
          return { allowed: true, remaining_capacity: null }; // Fail-open
        }

        const data = await response.json();
        console.log('[CAPACITY CHECK]', { eventId, requestedQuantity, response: data });
        
        return {
          allowed: data.allowed === true,
          remaining_capacity: data.remaining_capacity || null
        };
      } catch (error) {
        console.warn('Workshop: Capacity check failed', error);
        console.log('[CAPACITY CHECK]', { eventId, requestedQuantity, response: `Error: ${error.message}` });
        return { allowed: true, remaining_capacity: null }; // Fail-open
      }
    }

    // Shared capacity message helper. Inputs: R, X (event-level seats in cart), Y (requested add qty).
    // Standard capacity messages: R<=0 sold-out; R>0 and over capacity = "You're trying to add more..." + Only R spot(s) remain + Reduce to R or fewer.
    function buildCapacityResult(remainingCapacity, seatsAlreadyInCart, requestedAddQty) {
      const R = remainingCapacity ?? 0;
      const X = seatsAlreadyInCart ?? 0;
      const Y = requestedAddQty ?? 0;
      const allowedAdditional = Math.max(0, R - X);
      const ok = R > 0 && Y <= allowedAdditional;
      let message = '';
      if (R <= 0) {
        message = 'This workshop is sold out. You already have seats for this workshop in your cart. Remove seats to continue.';
      } else if (Y > allowedAdditional) {
        message = `You're trying to add more seats than the remaining capacity. Only ${R} spot(s) remain. Reduce the total seats for this workshop in your cart to ${R} or fewer.`;
      }
      return { ok, message, inCart: X, requested: Y, remaining: R, allowed: allowedAdditional };
    }

    // Validates capacity. Fetches cart once; returns cartData for reuse in _workshop_prices update.
    async function validateCapacityBeforeAdd(eventId, requestedQuantity) {
      const root = (window.Shopify?.routes?.root || '/');
      let cart = null;
      try {
        const res = await fetch(root + 'cart.js');
        cart = res.ok ? await res.json().catch(function() { return null; }) : null;
      } catch (e) {
        console.warn('Workshop: Failed to fetch cart', e);
      }

      try {
        const seatsAlreadyInCart = getSeatsFromCart(eventId, cart);
        const totalRequested = seatsAlreadyInCart + requestedQuantity;
        const capacityData = await checkWorkshopCapacity(eventId, totalRequested);

        if (!capacityData || capacityData.allowed === true) {
          return { allowed: true, remainingCapacity: capacityData?.remaining_capacity || null, adjustedQuantity: requestedQuantity, message: '', cartData: cart };
        }
        const remainingCapacity = capacityData.remaining_capacity ?? 0;
        const res = buildCapacityResult(remainingCapacity, seatsAlreadyInCart, requestedQuantity);

        if (res.remaining <= 0) {
          showToast(res.message);
          return { allowed: false, remainingCapacity: 0, adjustedQuantity: 0, abort: true, message: res.message, inCart: res.inCart, requested: res.requested, remaining: res.remaining, allowed: res.allowed, cartData: cart };
        }
        if (!res.ok) {
          showToast(res.message);
          return {
            allowed: false,
            remainingCapacity: res.remaining,
            adjustedQuantity: res.allowed <= 0 ? 0 : res.allowed,
            abort: res.allowed <= 0,
            message: res.message,
            inCart: res.inCart,
            requested: res.requested,
            remaining: res.remaining,
            allowed: res.allowed,
            cartData: cart
          };
        }
        return { allowed: true, remainingCapacity: res.remaining, adjustedQuantity: requestedQuantity, message: '', cartData: cart };
      } catch (error) {
        console.warn('Workshop: Capacity check failed', error);
        return { allowed: true, remainingCapacity: null, adjustedQuantity: requestedQuantity, message: '', cartData: cart };
      }
    }

    // Validate capacity before proceeding
    const capacityCheck = await validateCapacityBeforeAdd(selectedEventId, quantity);
    
    // If capacity check failed and we should abort, return early
    if (capacityCheck.abort === true) {
      return;
    }
    
    // If capacity check failed but we can adjust quantity, use adjusted quantity
    if (!capacityCheck.allowed && capacityCheck.adjustedQuantity > 0) {
      quantity = capacityCheck.adjustedQuantity;
      // Update quantity input to reflect adjusted value
      if (quantityInput) {
        quantityInput.value = quantity;
      }
    } else if (!capacityCheck.allowed) {
      // Should not happen if logic is correct, but fail-safe
      return;
    }

    // Line item properties — Cart Transform sadece _workshop ve _resolved_price* kullanır
    // _unique: variantId:eventId ile merge; aynı event+variant = tek satır
    let capacityRemaining = null;
    const capRaw =
      selectedCard?.dataset.capacityRemaining ||
      selectedCard?.getAttribute('data-capacity-remaining') ||
      null;
    if (capRaw != null) {
      const n = Number(capRaw);
      if (Number.isFinite(n) && n >= 0) {
        capacityRemaining = String(n);
      }
    }

    const uniqueId = `${variantId}:${selectedEventId}`;
    const centsStr = String(resolvedPriceCents ?? '').trim();
    const validCents = /^[0-9]+$/.test(centsStr) && parseInt(centsStr, 10) > 0;
    const eventMetaobjectGid = selectedCard?.dataset?.eventMetaobjectGid ? String(selectedCard.dataset.eventMetaobjectGid) : selectedEventId;
    // Line item properties: Shopify maps these to cart line attributes for Cart Transform
    const properties = {
      _workshop: 'true',
      _event_id: selectedEventId,
      _event_metaobject_gid: eventMetaobjectGid,
      _event_handle: eventHandle,
      _display_city: displayCity,
      _display_venue: displayVenue,
      _display_datetime: displayDatetime,
      _unique: uniqueId,
      _is_workshop: "1",
      "Booking Details": bookingDetailsVisible
    };
    if (validCents) {
      properties._resolved_price_cents = centsStr;
      properties._resolved_price = centsStr;
    } else {
      console.warn('[Workshop] Missing/invalid resolved cents', { resolvedPriceCents, variantId, eventId: selectedEventId });
    }
    if (capacityRemaining !== null) {
      properties._capacity_remaining = capacityRemaining;
      properties._capacity_source = 'metaobject_dom';
    }

    // Hard guard: prevent duplicate add within 1s (same event + variant + quantity)
    const addLockKey = selectedEventId + '|' + variantId + '|' + quantity;
    const lock = window.__WB_ADD_LOCK__;
    if (lock && (Date.now() - lock.ts) < 1000 && lock.key === addLockKey) {
      if (window.__WB_DIAG__) console.warn('[Workshop Cart] Duplicate add blocked (lock)', { key: addLockKey });
      e.preventDefault();
      return;
    }
    window.__WB_ADD_LOCK__ = { key: addLockKey, ts: Date.now() };

    const submitBtn = form.querySelector('button[type="submit"], button[name="add"]');
    const originalText = submitBtn ? submitBtn.textContent : '';
    window.__WORKSHOP_ADDING_TO_CART__ = true;
    let responseData;
    try {
      if (window.__WB_DIAG__) console.log('[Workshop Cart] REQUEST START add to cart', { eventId: selectedEventId, variantId: variantId, quantity: quantity });
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }
      const sectionsToRender = window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')
        ? window.Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
        : [];
      const root = (window.Shopify?.routes?.root || '/');
      const payload = buildCartAddPayload(variantId, quantity, properties, sectionsToRender);
      const endpoint = root + 'cart/add.js';

      const addResponse = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      responseData = await addResponse.json().catch(() => ({}));
      if (!addResponse.ok || responseData?.status === 422) {
        const desc = (responseData && responseData.description) ? String(responseData.description).toLowerCase() : '';
        const capacityRelated = /capacity|sold out|spots|seats|full|remaining|maximum|booked/.test(desc);
        const msg = capacityRelated && capacityCheck && capacityCheck.message
          ? capacityCheck.message
          : (responseData?.description || 'Unable to add to cart. Please try again.');
        alert(msg);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
        return;
      }
      if (validCents && capacityCheck.cartData) {
        try {
          var cartData = capacityCheck.cartData;
          var prices = {};
          try {
            if (cartData.attributes && cartData.attributes._workshop_prices) {
              prices = JSON.parse(cartData.attributes._workshop_prices);
            }
          } catch (_) {}
          prices[uniqueId] = centsStr;
          var keep = {};
          (cartData.items || []).forEach(function(it) {
            var u = it.properties && it.properties._unique;
            if (!u && it.properties && it.properties._event_metaobject_gid) u = (it.variant_id || it.id) + ':' + it.properties._event_metaobject_gid;
            if (u && prices[u] != null) keep[u] = prices[u];
          });
          if (keep[uniqueId] == null) keep[uniqueId] = centsStr;
          await fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { _workshop_prices: JSON.stringify(keep) } })
          });
        } catch (attrErr) {
          if (window.__WB_DIAG__) console.warn('[Workshop Cart] cart.attributes update failed', attrErr);
        }
      }
      if (responseData.sections && window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')) {
        window.Alpine.store('xCartHelper').reRenderSections(responseData.sections);
      }
      if (window.Alpine && window.Alpine.store && window.Alpine.store('xCartHelper')) {
        window.Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span')?.innerHTML || '0');
      }
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      if (window.Shopify && window.Shopify.theme && window.Shopify.theme.cartType === 'page') {
        window.location.href = '/cart';
      } else {
        if (window.Alpine && window.Alpine.store && window.Alpine.store('xMiniCart')) {
          if (!window.Alpine.store('xCartNoti') || !window.Alpine.store('xCartNoti').enable) {
            window.Alpine.store('xMiniCart').openCart();
          }
        }
      }
    } catch (err) {
      console.error('Workshop cart error:', err);
      const desc = (err && err.message) ? String(err.message).toLowerCase() : '';
      const capacityRelated = /capacity|sold out|spots|seats|full|remaining|maximum|booked/.test(desc);
      const msg = capacityRelated && capacityCheck && capacityCheck.message
        ? capacityCheck.message
        : 'Unable to add to cart. Please try again.';
      alert(msg);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    } finally {
      window.__WORKSHOP_ADDING_TO_CART__ = false;
      window.__WB_ADD_LOCK__ = null;
    }
  });

  if (window.__DEBUG_WORKSHOP_CAPACITY__) {
    console.log('[Workshop Cart] Event listeners attached');
  }
});
})(); // End IIFE guard
